import { LinearProgress, Paper } from '@mui/material';
import React, { Component } from 'react';
import PortalDataGridPro from '../../common/PortalDataGridPro';

class LocationTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
  };

  render() {
    return (
      <React.Fragment>
        <Paper
          id={this.props.id + '__paper_gridWrapper'}
          sx={{ width: '100%', overflow: 'hidden' }}
          elevation={0}
        >
          <PortalDataGridPro
            id={this.props.id + '__dataGrid_datatable'}
            rows={this.props.rows}
            columns={this.props.columns}
            handleClick={this.props.onClick}
            isLoading={this.props.isLoading}
            columnVisibilityModel={{
              ...this.props.columnVisibilityModel,
              createdAt: false,
            }}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            getRowId={(row) => {
              return row.id ? row.id : row.CATEGORY_ID.concat('_', row.PLACE_ID);
            }}
            slots={{
              ...this.props.slots,
              loadingOverlay: LinearProgress,
            }}
            pagination
            slotProps={this.props.slotProps}
            disableColumnFilter={this.props.disableColumnFilter}
            disableColumnSelector={this.props.disableColumnSelector}
            disableDensitySelector={this.props.disableDensitySelector}
          />
        </Paper>
      </React.Fragment>
    );
  }
}

export default LocationTable;
